import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import ZoomOutIcon from '@material-ui/icons/ZoomOut'
import RBarButton from './RBarButton'
import {
  zoomAtGlobalPoint,
  getContainerCenter
} from '../../../modules/reducerRotator'

const useStyles = makeStyles((theme) => ({
  root: {}
}))

const RZoomOutButton = (props) => {
  const classes = useStyles()
  const containerCenter = useSelector(getContainerCenter)
  const dispatch = useDispatch()

  const handleClick = useCallback(() => {
    dispatch(zoomAtGlobalPoint(false, containerCenter))
  }, [dispatch, containerCenter])

  return (
    <RBarButton
      {...props}
      tooltip="Zoom out"
      onClick={handleClick}
      disabled={false}
    >
      <ZoomOutIcon fontSize="inherit" />
    </RBarButton>
  )
}
export default RZoomOutButton
